// This is spoopy. We need to actually depend on the package inside this monorepo.
// Scott recommended this approach because legacy is tricky, and we don't have time
// right now to test thoroughly.
const currencyJson = require('../../../../legacy/dist/vendor/money-parser/data/currency.json');

/**
 * Parse an amount into a float for money
 * @param amount
 * @param locale
 * @returns {*|number}
 */
window.parseMoney = (amount, locale = null) => {
  if (typeof amount === 'undefined' || amount === '' || amount === 0) {
    return 0.0;
  }

  // Ensure the amount is a string
  const stringAmount = amount.toString();

  if (locale && locale !== 'en') {
    try {
      const parsedAmountLocale = window.Globalize(locale).numberParser()(
        stringAmount,
      );
      if (!Number.isNaN(parsedAmountLocale)) {
        return parsedAmountLocale;
      }
    } catch {
      // Missing package - fallback to `en`
    }
  }

  return window.Globalize('en').numberParser()(stringAmount) || 0.0;
};

/**
 * Load a currency into the cldr for parsing
 *
 * @param json
 */
window.loadCurrencyParser = (json) => {
  if (window.Cldr) {
    window.Cldr.load(json);
  }
};

window.loadCurrencyParser(currencyJson);
